import { CaseTimeline } from '../CaseTimeline';

interface TimelineTabProps {
  patientId: string;
}

export function TimelineTab({ patientId }: TimelineTabProps) {
  return <CaseTimeline patientId={patientId} />;
}
